import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { EstensioneService } from 'src/app/services/estensione.service';
import { ToastrService } from 'ngx-toastr';
import { extensions } from '../config'
import { Estensione } from 'src/app/models/estensione';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-disabled-incaricato-accertatore',
  templateUrl: './disabled-incaricato-accertatore.component.html',
  styleUrls: ['./disabled-incaricato-accertatore.component.scss']
})
export class DisabledIncaricatoAccertatoreComponent {

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private toast: ToastrService,
    private router: Router
  ) { }

  slug: string = 'disabled_accertatore_incaricato';
  form: FormGroup;
  loggedInUser: User;
  params: any;
  //constantIMBuser: String = '1319e9d0-ae34-45ad-9e8b-475195c6f6f1'
  extension: Estensione

   async ngOnInit(): Promise<any> {
    this.loggedInUser = this.authService.loggedInUser.getValue();
    console.log(this.loggedInUser)
  
   
    this.form = this.fb.group({
      enabled:  false,
    });

    try {
      this.extension = await this.estensioneService.bySlug(extensions[this.slug]);
      console.log(this.extension)
      if (this.extension && this.extension.id) {
        this.form.patchValue({
          enabled: this.extension.enabled,
        }) 
      }
     } catch(e) {
      console.error(e)
     }
  }

  async Salva() {
    console.log(this.form);

    this.params = {
      slug: extensions[this.slug],
      configuration: null,
      enabled: this.form?.value.enabled ? this.form.value.enabled : false,
      studio_id: this.loggedInUser.studio_id
    }
    console.log(this.params);
    let res = await this.estensioneService.saveOrUpdate(this.params, this.slug);

    if (res.created && res.updated) {
     return this.toast.error("Errore nel server");
    }

    if (res.created) 
      return this.toast.success("Configurazione creata");

    if (res.updated)
      return this.toast.success("Configurazione salvata");
  }
}
